import React, { useRef } from 'react';
import { ReactComponent as ChevronDoubleDown } from '../svg/chevrons-down-double.svg';
import { HIDDEN_BUTTON_CLASS } from '../redux/constants/constants';
import useTotal from '../hooks/useTotal';
import useTotalDiscount from '../hooks/useTotalDiscount';
import { connect } from 'react-redux';

function TotalBill() {
    const proceedButton = useRef();
    const total = useTotal();
    const totalDiscount = useTotalDiscount();

    const goToTop = () => {
        document.body.scrollIntoView(false);
    };

    const isScrolledIntoView = (el) => {
        let rect = el.getBoundingClientRect();
        let elemTop = rect.top;
        let elemBottom = rect.bottom;

        return elemTop >= 0 && elemBottom <= window.innerHeight;
    };

    document.addEventListener('scroll', () => {
        if (proceedButton?.current?.classList) {
            if (isScrolledIntoView(document.querySelector('.card__list'))) {
                proceedButton.current.classList.add(HIDDEN_BUTTON_CLASS);
            } else {
                proceedButton.current.classList.remove(HIDDEN_BUTTON_CLASS);
            }
        }
    });

    return (
        <div
            className={
                'flex flex--space-between flex--align-baseline header__link-border header__link-border--space-32'
            }
        >
            <button
                type={'button'}
                onClick={() => goToTop()}
                className={'button--reset button--icon-move-down no-wrap'}
                ref={proceedButton}
            >
                <span className={'text-3 color--blue'}>Total {total}</span>
                <span className={'visually-hidden'}>Proceed to payment</span>
                <ChevronDoubleDown className={'icon size-23 ml-4 color--blue'} />
            </button>
        </div>
    );
}

export default connect(null, null)(TotalBill);
